import { Component, SimpleChanges, Inject, PLATFORM_ID } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { ActivatedRoute, Router } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CoreState } from '@app/store/core/states';
import { environment } from '@app/env/environment';
import { UtilityHelper } from '@framework/utilities';
import { Page } from '@framework/base';
import * as adminStoryActions from '@modules/company-admin/store/actions';
import { landingPageActions, companyActions, searchBoxActions } from '@modules/company/store/actions';
import { companySelectors, landingPageSelectors, searchBoxSelectors } from '@modules/company/store/selectors';
import { CompanyViewModel, LandingPageViewModel, SearchBoxStateViewModel } from '@modules/company/models/store-view-models';
import { storyActions } from '@modules/story/store/actions';
import { SeoService } from '@modules/shared/services/seo.service';
import { MetaTagConfig } from "@modules/shared/models/common/seo.model";
import { storySelector } from '@modules/story/store/selectors';
import { StoryFacetedSearchViewModel } from '@modules/story/models/store-view-models';
import { Constants } from '@modules/shared/constants';
import { CtaFormConfigViewModel } from '@modules/story/models/view-models';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SearchStoryInputApiModel, SubmitCtaInputApiModel } from '@modules/story/models/api-models/input';
import { JobLinkacAction, nudgesSettingActions, ScriptActions } from '@modules/company-admin/store/actions';
import { isPlatformBrowser } from '@angular/common';
import { CompanyHttpService } from '@modules/company/services/company.http-service';

declare const gtag: Function;
declare var dataLayer;
declare var window:any;
declare var $: any;

let measuremnetId;
let pagename;
let globalTag;
@Component({
  selector: 'app-public-featured-page',
  templateUrl: './public-featured.page.html',
  styleUrls: ['./public-featured.page.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        height: '*',
        opacity: 1,
        overflow: 'visible'
      })),
      state('out', style({
        height: '0',
        opacity: 0,
        overflow: 'hidden'
      })),
      transition('in => out', [
        animate('300ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ]),
      transition('out => in', [
        animate('300ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ])
    ])
  ]
})
export class LandingPage extends Page {
  // Private variables
  private selectCompany$: Observable<CompanyViewModel>;
  private selectLandingPageDetail$: Observable<LandingPageViewModel>;
  private baseUrl: string = environment.baseUrl;

  private selectCompanySubscription: Subscription;
  private selectLandingPageDetailSubscription: Subscription;
  private submitCtaSuccessSubscription: Subscription;
  public primary_cmarr:any;
  public button_text_color:any;
  private LoadSuccessSubscriptin: Subscription;
  private loadFrequentTagsSuccess: Subscription;
  public showbbuttontext: any;
  public loadColorSuccessSubscription: Subscription;

  private landingPageSlug: string = '';
  public ctaForm: UntypedFormGroup;
  private selectSearchBoxStatus$: Observable<SearchBoxStateViewModel>;
  private queryStoriesData: SearchStoryInputApiModel = new SearchStoryInputApiModel();
  // Public variables
  public showJobslist:any[] = [];
  public selectedCompany: CompanyViewModel;
  public landingPage: LandingPageViewModel;
  public isIframeMode: boolean = false;
  public frequenttags: any;
  public showtagsboolean: boolean = true;
  public showHeaderboolean: boolean = true;
  public showDonor:boolean = false;
  public isShowNudgeButton: boolean;
  public ctaStepActivated: number = 0;
  public interestSelected: any;
  public weAppreciate: number = 8;
  public weValue: number = 14;
  public isShowNudge: boolean;
  public ourVibes: number = 13;
  public ourteams: number = 2;
  public ourChallenges: number = 11;
  counter = new Array(3);
  public searchBoxStatus: SearchBoxStateViewModel;
  public selectFacetedSearchResultSubscription: Subscription;
  public selectSearchBoxStatusSubscription: Subscription;
  private selectFacetedSearchResult$: Observable<StoryFacetedSearchViewModel>;
  public loadDetailFromAPISubcription: Subscription;
  public loadNudgesettingsSubscription: Subscription;
  public isNudgeBasic: boolean = false;
  public isNudgeComplex: boolean = false;
  public isNudgeDonation: boolean = false;
  public isShowToggleActive: boolean = false;
  public isNudgeJob: boolean = false;
  public  isBrowser: boolean;
  public companySlug:string;
  public isBottom: boolean = false;
  public isFirst: boolean = true;
  public text_color:any;
  public button_color: any;
  public view_type:any;
  public showFooter: boolean = true;
  public enable_tags:boolean = false;
  public isTagSectionVisible: boolean = true; // Toggle visibility state - start expanded
  private loadJlinkobsSubscription: Subscription;
  submit_text_Color: any;
  submit_btn: any;
  constructor(private activatedRoute: ActivatedRoute, private router: Router, 
    private store$: Store<CoreState>,
    private utility: UtilityHelper,
    private actions$: Actions,
    @Inject(PLATFORM_ID) platformId: Object,
    private companyHttpService: CompanyHttpService,
    private seoService: SeoService,private formBuilder: UntypedFormBuilder) {
    super();
    this.isBrowser = isPlatformBrowser(platformId);
    this.selectCompany$ = this.store$.select(companySelectors.selectSelectedCompany);
    this.selectLandingPageDetail$ = this.store$.select(landingPageSelectors.selectLandingPage);
    this.selectFacetedSearchResult$ = this.store$.select(storySelector.selectFacetedSearchResults);
    this.selectSearchBoxStatus$ = this.store$.select(searchBoxSelectors.selectSearchBoxStatus);


    this.captureParams();
  }

  // Life cycle hook
  protected onInit(): void {
    if(this.isBrowser){
      this.updateTagsForSSR();
      this.subscribe();
      this.ctaForm = this.formBuilder.group({
        interested: ['', this.step1Require.bind(this)],
        email: ['', Validators.compose([Validators.email, this.step2Require.bind(this)])],
        fullName: ['', this.step2Require.bind(this)]
      });
      if (window.location !== window.parent.location) {
        // this.insideIframe = true;
        var storedata = window.location.href.split("?");
        localStorage.setItem('iframehref',window.location.href)
        if(storedata.length == 2){
          if(storedata[1].split('&').includes('showHeader=true')){
            this.showHeaderboolean = true;
          }
          else{
            this.showHeaderboolean = false;
          }
  
          if(storedata[1].split('&').includes('showtagheader=true')){
            this.showtagsboolean = true;
          }
          else{
            this.showtagsboolean = false;
          }
          if(storedata[1].split('&').includes('showfooter=true')){
            this.showFooter = true;
            localStorage.setItem('showfooter','true')
          }
          else{
            localStorage.setItem('showfooter','false')
            this.showFooter = false;
          }
        }
        else{
          localStorage.setItem('showfooter','true')
          this.showHeaderboolean = false;
          this.showtagsboolean = false;
          this.showFooter = true;
        }
        //document.getElementsByClassName("site-container")[0]['style'].padding = 0;
      } else {
        localStorage.setItem('showfooter','true')
        this.showHeaderboolean = true;
        this.showtagsboolean = true;
        this.showFooter = true;
      }
    }
    else{
       this.updateTagsForSSR();
    }

  }
  protected onDestroy(): void {
    if(this.isBrowser){
      this.unsubscribe();
      this.resetStates();
      this.removeScripts();
      this.closeDonor();
    }

    this.seoService.clearMetaTags();
  }
  protected onChanges(changes: SimpleChanges): void {

  }
  protected onDoCheck(): void {

  }
  protected onAfterContentInit(): void {

  }
  protected onAfterContentChecked(): void {

  }
  protected onAfterViewInit(): void {
    
  }
  protected onAfterViewChecked(): void {
    if (this.isIframeMode) {
      this.sendPostMessage();
    }
  }

  // Private functions
  private addMetaTags(): void {
    const config: MetaTagConfig = new MetaTagConfig();
    config.title = this.landingPage.title;
    config.url = `${environment.baseUrl}${this.router.url}`;
    config.image = this.landingPage.headerImage;
    config.description = this.landingPage.slogan;
    this.seoService.updateMetaTags(config);
  }

  private subscribe() {
    this.selectCompanySubscription = this.selectCompany$.subscribe((company) => {
      if (company) {
        this.selectedCompany = company;
        // this.enable_tags = company?.enable_tags;
        this.store$.dispatch(new nudgesSettingActions.LoadNudgeSettings(this.selectedCompany.id));
        pagename = this.selectedCompany.name+'PUBLIC_SPOTLIGHT_PAGE'
        this.loadScripts();
        this.loadDetail();
      }
    });

    this.LoadSuccessSubscriptin = this.actions$.pipe(
      ofType<ScriptActions.LoadSuccess>(ScriptActions.ActionTypes.LOAD_SUCCESS)
    ).subscribe((action:any) => {
         
      if(action && action.response.results && action.response.results.length){
        var scripts = action.response.results.filter(script => script.is_accessible);
        if(this.isBrowser){
          this.appendScriptinProduct(scripts);
        }

  
      }
    });
    this.loadJlinkobsSubscription = this.actions$.pipe(
      ofType<JobLinkacAction.GetSpotlightJobsSuccess>(JobLinkacAction.ActionTypes.GET_SPOTLIGHT_JOBS_SUCCESS)
    ).subscribe((action:any) => {
      if(action.response){
        this.showJobslist = this.shouldShowCtaJobs
          ? (action.response?.filter(job => job.is_accessible) || [])
          : [];
      }
    });

    this.loadColorSuccessSubscription = this.actions$.pipe(
      ofType<adminStoryActions.storyActions.GetColorSuccess>(adminStoryActions.storyActions.ActionTypes.GET_BUTTON_COLOR_SUCCESS)
    ).subscribe((action: any) => {
      if(action && action.response && action.response && action.response.length){
        this.primary_cmarr= action.response.find(item => item.button == 11).color;
        this.submit_text_Color = action.response.find(item => item.button == 10).color;
        this.submit_btn = action.response.find(item => item.button == 7).color;
        // this.backgroundImageColor = action.response.find(item => item.button == 14).color;
       }
      

    })

    this.loadDetailFromAPISubcription = this.actions$.pipe(
      ofType<landingPageActions.LoadDetailSuccess>(landingPageActions.ActionTypes.LOAD_DETAIL_SUCCESS)
    ).subscribe((action) => {
      if(action.response){
         this.getfrequentTags();
      }
    });

    this.loadNudgesettingsSubscription = this.actions$.pipe(
      ofType<nudgesSettingActions.LoadNudgeSettingsSuccess>(nudgesSettingActions.ActionTypes.LOAD_NUDGE_SETTING_SUCCESS)
    ).subscribe((action:any) => {
       if(action && action.response){
         this.text_color = action.response.text_color;
         this.button_color = action.response.button_color;
         this.button_text_color = action.response.button_text_color
         this.view_type = action.response.view_type;
       }
    });

    this.submitCtaSuccessSubscription = this.actions$.pipe(
      ofType<landingPageActions.SubmitCtaSuccess>(landingPageActions.ActionTypes.SUBMIT_CTA_SUCCESS)
    ).subscribe(() => {
      this.ctaStepActivated = 3;
    });
    this.selectLandingPageDetailSubscription = this.selectLandingPageDetail$.subscribe((landingPage) => {
      if (landingPage) {
        this.landingPage = landingPage;
        this.loadStorylinkedJobs();
        if(this.landingPage && this.landingPage.cta && this.landingPage.cta.config){
          let data = JSON.parse(this.landingPage.cta.config)
          if(data.button_text == '' || data.button_text == null){
            this.showbbuttontext = this.landingPage.cta.button;
          }
          else{
            this.showbbuttontext = data.button_text;
          }
        }
        else{
          this.showbbuttontext = this.landingPage?.cta?.button
        }
        this.checkPermission();
        this.addMetaTags();
      }
    });

    // this.selectFacetedSearchResultSubscription = this.selectFacetedSearchResult$.subscribe((result: StoryFacetedSearchViewModel) => {
    //   if (result) {
    //     this.frequenttags = result.frequent_tags
    //   }
    // });
    this.loadFrequentTagsSuccess = this.actions$.pipe(
      ofType<storyActions.LoadSpotlightFrequentTagsSuccess>(storyActions.ActionTypes.LOAD_SPOTLIGHT_FREQUENT_TAGS_SUCCESS)
    ).subscribe((action: any) => {
      if(action){
        this.frequenttags = action.data?.frequent_tags;
        for (const key in this.frequenttags) {
          if (this.frequenttags[key].is_header_part == true) {
            this.enable_tags = true;
            break;
          }
        }
      }
    });
    this.selectSearchBoxStatusSubscription = this.selectSearchBoxStatus$.subscribe((state: any) => {
      this.searchBoxStatus = state;
    });

  }

  public removeScripts(){
    $("#pvt__scripts").empty();
   }

  

  private unsubscribe() {
    this.selectCompanySubscription.unsubscribe();
    this.selectLandingPageDetailSubscription.unsubscribe();
    this.submitCtaSuccessSubscription.unsubscribe();
    this.loadDetailFromAPISubcription.unsubscribe();
    this.loadFrequentTagsSuccess.unsubscribe();
    this.LoadSuccessSubscriptin.unsubscribe();
    this.loadNudgesettingsSubscription.unsubscribe();
    this.store$.dispatch(new landingPageActions.Reset())
  }

  private loadScripts() {
    this.store$.dispatch(new ScriptActions.Load(this.selectedCompany.id));
  }


  getNames(number){
    var name = '';
    if(this.frequenttags && this.frequenttags[number] && this.frequenttags[number].header_title){
      if(number == 2){
        name = this.frequenttags[number].header_title.toLowerCase() == 'roles' ? 'Teams' : this.frequenttags[number].header_title;
         
      }
      if(number == 8){
        name = this.frequenttags[number].header_title.toLowerCase() == 'impact' ? 'Skills' : this.frequenttags[number].header_title;
         
      }
      if(number == 13){
        name = this.frequenttags[number].header_title.toLowerCase() == 'feeling' ? 'Vibes' : this.frequenttags[number].header_title;
         
      }
      if(number == 14){
        name = this.frequenttags[number].header_title.toLowerCase() == 'values' ? 'Values' : this.frequenttags[number].header_title;
         
      }
    }

    return name;
  }



get isMobile() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];
  const isAgentMobile = toMatch.some((toMatchItem) =>
    navigator.userAgent.match(toMatchItem)
  );

  // A large-screen Android device (e.g. Lenovo 32" 4K tablet)
  // reports ~1920px innerWidth — don't treat it as mobile
  return isAgentMobile && window.innerWidth <= 899;
}


  public appendScriptinProduct(script){

    let googleAnalyticsScript = script.find(scripttype => scripttype.type == 'GoogleAnalytics');

    if(googleAnalyticsScript && $("#pvt__scripts").html() === ""){
      this.googleAnalyticsScripts(googleAnalyticsScript.measurement_id)
      measuremnetId = googleAnalyticsScript.measurement_id
      setTimeout(()=>{
        gtag('event', 'page_view', {
          page_title: pagename,
          page_path: window.location.pathname,
          page_location: window.location.href,
          send_to: measuremnetId
       })
      },5000)
    }
    // else{
    //   setTimeout(()=>{
    //     gtag('event', 'page_view', {
    //       page_title: pagename,
    //       page_path: window.location.pathname,
    //       page_location: window.location.href,
    //       send_to: measuremnetId
    //    })
    //   },1000)
    // }
  }


  public googleAnalyticsScripts(tag){
  /**   let elementScript = document.createElement('script');
         elementScript.src = `https://www.googletagmanager.com/gtag/js?id=${tag}`;
         elementScript.async = true;
         document.getElementById('pvt__scripts').appendChild(elementScript);
    let elementScriptText = document.createElement('script');
    elementScriptText.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date()); gtag('config', ${tag},{send_page_view: false});`
    document.getElementById('pvt__scripts').appendChild(elementScriptText); */

    globalTag = tag;
    let elementScript = document.createElement('script');
    elementScript.src = `https://www.googletagmanager.com/gtag/js?id=${tag}`;
    elementScript.async = true;
    document.getElementById('pvt__scripts').appendChild(elementScript);
  
    // Wait for the script to load before calling gtag()
    elementScript.onload = () => {
      // Ensure window.dataLayer is initialized
      window.dataLayer = window.dataLayer || [];
      
      // Define gtag function globally
      window['gtag'] = function gtag() {
        window.dataLayer.push(arguments);
      };
  
      // Initialize gtag
      gtag('js', new Date());
  
      // Configure Google Analytics
      gtag('config', globalTag, { send_page_view: false });
    };

  }

  private loadDetail() {
    this.store$.dispatch(new landingPageActions.LoadDetail(this.selectedCompany.id, this.landingPageSlug));
  }

  private captureParams() {
    this.landingPageSlug = this.activatedRoute.snapshot.params['pageSlug'];
    const companySlug = this.activatedRoute.snapshot.params['slug'];
    this.companySlug = companySlug
    this.isIframeMode = this.activatedRoute.snapshot.queryParams.iframe == 1;

    this.store$.dispatch(new companyActions.LoadPublicInfo(companySlug));
  }


  private getDocHeight() {
    const doc = window.document;
    // from http://stackoverflow.com/questions/1145850/get-height-of-entire-document-with-javascript
    const body = doc.body, html = doc.documentElement;
    const height = Math.max(body.scrollHeight, body.offsetHeight,
      html.clientHeight, html.scrollHeight, html.offsetHeight);
    return height;
  }

  private sendPostMessage() {
    if (window) {
      const message = JSON.stringify({ 'docHeight': this.getDocHeight() })
      window.parent.postMessage(message, '*');
    }
  }

  private resetStates(){
    this.store$.dispatch(new storyActions.ResetState());
    this.store$.dispatch(new searchBoxActions.ResetState());
  }
  // Public functions

  public filterTag(tag){
    var tagInserted = this.checktagshistory(tag)
    var payload = {tags: tagInserted}
    this.store$.dispatch(new searchBoxActions.SearchPayload(payload))
    this.store$.dispatch(new searchBoxActions.Show());
    this.store$.dispatch(new searchBoxActions.Search({ tags: tagInserted }));
  }

  private checkPermission() {
    this.isShowNudge = this.landingPage &&
      this.landingPage.cta && this.landingPage.cta.type 

    this.isNudgeBasic = this.landingPage && this.landingPage.cta && this.landingPage.cta.type === Constants.nudgeMode.basic;
    this.isNudgeDonation = this.landingPage && this.landingPage.cta && this.landingPage.cta.type === Constants.nudgeMode.donation;
    this.isNudgeComplex = this.landingPage && this.landingPage.cta && this.landingPage.cta.type === Constants.nudgeMode.advanced;
    this.isNudgeJob = this.landingPage && this.landingPage.cta && this.landingPage.cta.type === Constants.nudgeMode.jobs;

    // Complex CTAs with no enabled interest options but a link should render like a simple CTA
    // (avoids blank buttons / empty multi-step forms from misconfigured templates).
    if (this.isNudgeComplex && !this.hasEnabledCtaForms && this.landingPage?.cta?.link) {
      this.isNudgeComplex = false;
      this.isNudgeBasic = true;
    }

    this.isShowNudgeButton = this.isNudgeBasic || this.isNudgeDonation || this.isNudgeJob ||
      (this.isNudgeComplex && this.hasEnabledCtaForms);

    if (!this.shouldShowCtaJobs) {
      this.showJobslist = [];
    }
  }

  /** Featured job links only when the selected CTA allows jobs. */
  get shouldShowCtaJobs(): boolean {
    if (!this.landingPage?.cta) {
      return false;
    }
    if (this.landingPage.cta.type === Constants.nudgeMode.jobs) {
      return true;
    }
    return this.isTruthyFlag(this.landingPage.cta.show_jobs);
  }

  get hasEnabledCtaForms(): boolean {
    const configs = this.landingPage?.cta_form_configs;
    if (!configs?.length) {
      return false;
    }
    return configs.some((item: any) => this.isTruthyFlag(item?.is_enabled) || this.isTruthyFlag(item?.isEnabled));
  }

  get ctaComplexButtonLabel(): string {
    return this.landingPage?.cta?.conditional_button_text || this.landingPage?.cta?.button || '';
  }

  isTruthyFlag(value: unknown): boolean {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  get hasSelectedInterestRedirect(): boolean {
    return !!(this.interestSelected && this.isTruthyFlag(this.interestSelected.is_redirection ?? this.interestSelected.isRedirection) && this.selectedInterestLink);
  }

  get selectedInterestLink(): string {
    if (!this.interestSelected) {
      return '';
    }
    return this.interestSelected.link || this.interestSelected.redirectionLink || '';
  }

  get selectedInterestButtonText(): string {
    if (!this.interestSelected) {
      return '';
    }
    return this.interestSelected.text || this.interestSelected.redirectionText || 'Continue';
  }

  get selectedInterestThankYouText(): string {
    if (!this.interestSelected) {
      return '';
    }
    return this.interestSelected.thank_you_text || this.interestSelected.thankYouText || this.interestSelected.thankyouText || 'Thank you!';
  }
  checktagshistory(tag){

    var tagStore = [];
    if(this.searchBoxStatus && this.searchBoxStatus.searchpayload){

      if(this.searchBoxStatus.searchpayload.tags.length){
        
        tagStore = this.searchBoxStatus.searchpayload.tags;
        tagStore.push(tag);
      }
      else{
          
         tagStore = [tag]
      }
    }
    else{
      tagStore = [tag];
    }
    return tagStore;
  }

  closeDonor(){
    if(this.showDonor){
      this.showDonor = false;
      document.getElementById('donation_form').innerHTML = ''
    }
    else{
      return;
    }

  }


  showDonation(){
    if(this.isBrowser){
      let tokenurl = '';
      let cls = btoa(this.primary_cmarr)
      let left = (screen.width - 1200) / 2;
      let top = (screen.height - 640) / 4;
      if(this.landingPageSlug && this.landingPage?.id && this.landingPage?.cta  && this.landingPage?.cta?.cta_slug){
        tokenurl =this.landingPage?.cta?.cta_slug;
      }
      else{
        tokenurl = 'action';
      }
      let url = window.location.origin+'/cta-action/'+tokenurl+'?'+'sid='+this.landingPageSlug+'&cid='+this.selectedCompany?.id+'&cls='+cls
      window.open(url, "_blank", 'resizable=yes, width=' + 1200
                + ', height=' + 640 + ', top='
                + top + ', left=' + left);
    }

  }
  openComplexForm(){
    this.toggleShowActive();
    this.openStep1();
  }
  public hexToRgbA(hex) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = '0x' + c.join('');
      return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',0.3)';
    }
  }
  public openStep1() {
    this.ctaStepActivated = 1;
  }

  public openStep2() {
    this.ctaForm.controls.interested.updateValueAndValidity();
    this.ctaForm.controls.interested.markAsDirty();
    if (!this.ctaForm.valid) { return; }

    this.interestSelected = this.landingPage?.cta_form_configs.find(f => f.title === this.ctaForm.controls.interested.value);
    if (this.isTruthyFlag(this.interestSelected?.is_required_info ?? this.interestSelected?.isRequiredInfo)) {
      this.ctaStepActivated = 2;
      return;
    }

    this.ctaFormSubmit();
  }

  public closeStep() {
    this.ctaStepActivated = 0;
    this.toggleShowActive();
  }

  private step1Require(control: UntypedFormControl) {
    if (this.ctaStepActivated !== 1) { return null; }

    const value = control.value;
    if (!value) {
      return {
        isCustom: true,
        message: 'Required.'
      };
    }
    return null;
  }
  private loadStorylinkedJobs(){
    this.store$.dispatch(new JobLinkacAction.GetSpotlightJobs(this.landingPage.id));
  }
  public ctaFormSubmit() {
    this.utility.Form.updateFormGroupValidity(this.ctaForm);
    this.utility.Form.markFormGroupDirty(this.ctaForm);
    if (!this.ctaForm.valid) { return; }

    const submitData: Partial<SubmitCtaInputApiModel> = {
      content: {
        question_text: this.ctaForm.controls.interested.value
      },
      template_id: this.landingPage.cta.config,
      cta_button: this.landingPage.cta.button
    };
    if (this.isTruthyFlag(this.interestSelected?.is_required_info ?? this.interestSelected?.isRequiredInfo)) {
      submitData.full_name = this.ctaForm.controls.fullName.value;
      submitData.email = this.ctaForm.controls.email.value;
    }
    this.store$.dispatch(new landingPageActions.SubmitCta(this.selectedCompany.id, this.landingPage.slug,submitData));
  }

  getfrequentTags(){
    this.queryStoriesData.companyId = this.selectedCompany.id;
    this.queryStoriesData.campaigns = this.landingPage.queryObjects.facetedCampaignSelected ? this.landingPage.queryObjects.facetedCampaignSelected.map(m => m.id) : [];
    this.queryStoriesData.tags = this.landingPage.queryObjects.facetedTagSelected ? this.landingPage.queryObjects.facetedTagSelected.map(m => m.name) : [];
    this.queryStoriesData.peoples = this.landingPage.queryObjects.facetedPeopleSelected ? this.landingPage.queryObjects.facetedPeopleSelected.map(m => m.id) : [];
    this.queryStoriesData.includeStory = this.landingPage?.queryObjects?.queryStories?.includeStory;
    this.queryStoriesData.includeTestimonial = this.landingPage?.queryObjects?.queryStories?.includeTestimonial;
    this.queryStoriesData.internal = this.landingPage?.queryObjects?.queryStories?.internal;
    this.queryStoriesData.spotlightOnly = this.landingPage?.queryObjects?.queryStories?.spotlightOnly;
    this.queryStoriesData.public = true;
    this.queryStoriesData.spotlightOnly = true;
    this.queryStoriesData.pagination.sort ="desc"
    this.queryStoriesData.pagination.sortBy = 'published_at';

    this.store$.dispatch(new storyActions.LoadSpotlightFrequentTags(this.queryStoriesData));
   }

  public toggleShowActive() {
    this.isShowToggleActive = !this.isShowToggleActive;
    this.isFirst = false;
  }
  private step2Require(control: UntypedFormControl) {
    if (this.ctaStepActivated !== 2) { return null; }

    const value = control.value;
    if (!value) {
      return {
        isCustom: true,
        message: 'Required.'
      };
    }
    return null;
  }
  public addCtaHit(url){
    // let obj ={"tracking_id":this.alltrackingpayload.find(cta => Object.keys(cta).includes('cta')).tracking_id}
    // this.addtrackhit(obj)
    if(url.includes("https://") && url.split('//').length > 1){
    window.open(url, '_blank');
    }
    else{
      let data = 'https://'+url;
      window.open(data, '_blank');
    }
   

  }
  updateTagsForSSR(){
    this.companyHttpService.loadDetailLandingPage(this.companySlug, this.landingPageSlug).subscribe((res: any)=>{
      if(res){
        this.ssraddMetaTags(res);
      }
  
    })
   }
  private ssraddMetaTags(res): void {
    const config: MetaTagConfig = new MetaTagConfig();
    config.title = res.title;
    config.url = 'https://'+this.companySlug+'.'+environment.customUrl+'/c/'+this.companySlug+'/featured/'+this.landingPageSlug;
    if(!res.header_media){
      config.image ='https://'+this.companySlug+'.'+environment.customUrl+res.header_image;
    }
    else{
      config.image = res.header_image;
    }
    config.alt = res.title
    config.description = 'Spotlight Page'
    
    this.seoService.updateMetaTags(config);
  }

  showorhide(data){
    if(this.frequenttags && this.frequenttags && this.frequenttags[data.toString()]){
      return this.frequenttags[data.toString()]?.is_header_part;
    }
    // return true
  }

  // Toggle tag section visibility
  public toggleTagSection(): void {
    this.isTagSectionVisible = !this.isTagSectionVisible;
  }
}

